<template>
  <div>
    <form class="md:flex md:align-top" @submit.prevent="submitFilters">
      <div
        class="mb-16 grid flex-1 grid-cols-2 gap-16 overflow-hidden md:grid-cols-5"
        :class="{ 'max-h-56': !shouldShowAllFilters }"
      >
        <RevInputText
          id="order-id"
          v-model="filtersValues.orderId"
          :label="i18n(sharedTranslations.orderId)"
          type="number"
        />
        <RevInputDate
          id="start-date"
          v-model="filtersValues.startDate"
          :label="i18n(sharedTranslations.startDate)"
        />
        <RevInputDate
          id="end-date"
          v-model="filtersValues.endDate"
          :label="i18n(sharedTranslations.endDate)"
          :picked-date-attrs="{ 'data-allow-mismatch': 'text' }"
        />
        <RevInputText
          id="sku"
          v-model="filtersValues.sku"
          :label="i18n(sharedTranslations.sku)"
          type="text"
        />
        <RevInputSelect
          v-if="shouldShowMissingActionFilter"
          id="missing-action"
          v-model="filtersValues.missingAction"
          :label="i18n(sharedTranslations.missingAction)"
          :options="missingActionOptions"
        />
        <RevInputSelect
          v-if="shouldShowOrderStateFilter"
          id="state"
          v-model="filtersValues.state"
          :label="i18n(sharedTranslations.orderState)"
          :options="statesOptions"
        />
        <RevInputSelect
          v-if="shouldShowBackshipFilter"
          id="isBackship"
          v-model="filtersValues.isBackship"
          :label="i18n(sharedTranslations.backShip)"
          :options="backshipOptions"
        />
        <RevInputText
          id="customer-first-name"
          v-model="filtersValues.customerFirstName"
          :label="i18n(sharedTranslations.customerFirstName)"
          type="text"
        />
        <RevInputText
          id="customer-last-name"
          v-model="filtersValues.customerLastName"
          :label="i18n(sharedTranslations.customerLastName)"
          type="text"
        />
        <RevInputSelect
          id="market"
          v-model="filtersValues.market"
          :label="i18n(sharedTranslations.market)"
          :options="availableMarketsOptions"
        />
        <RevInputSelect
          id="carrierId"
          v-model="filtersValues.carrierId"
          :label="i18n(sharedTranslations.shippingProvider)"
          :options="shippingProvidersOptions"
        />
        <RevInputSelect
          id="order-date-type"
          v-model="filtersValues.dateType"
          :label="i18n(sharedTranslations.dateType)"
          :options="dateTypeOptions"
        />
        <RevInputText
          id="order-line-id"
          v-model="filtersValues.orderLineId"
          :label="i18n(sharedTranslations.orderLineId)"
          type="number"
        />
      </div>
      <div class="ml-16">
        <RevButton type="submit" variant="primary">
          {{ i18n(sharedTranslations.submit) }}
        </RevButton>
        <RevLink class="ml-16" type="button" @click="resetFilters">
          {{ i18n(sharedTranslations.reset) }}
        </RevLink>
      </div>
    </form>
    <div class="mb-8">
      <RevButton size="small" variant="secondary" @click="toggleMoreFilters">
        <template v-if="shouldShowAllFilters">
          {{ i18n(translations.showLess) }}
        </template>
        <template v-else>
          {{ i18n(translations.showMore) }}
        </template>
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInputDate } from '@ds/components/InputDate'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'
import { RevLink } from '@ds/components/Link'

import { useFiltersOptions } from '../../../../composables/useFiltersOptions'
import sharedTranslations from '../../Filters.translations'
import type { FilterValues } from '../../Filters.types'

import translations from './FiltersDesktop.translations'

const i18n = useI18n()

const filtersValues = defineModel<FilterValues>('filtersValues', {
  required: true,
})

defineProps<{
  resetFilters: () => void
  submitFilters: () => void
  shouldShowMissingActionFilter: boolean
  shouldShowOrderStateFilter: boolean
  shouldShowBackshipFilter: boolean
}>()

const {
  availableMarketsOptions,
  backshipOptions,
  dateTypeOptions,
  missingActionOptions,
  statesOptions,
  shippingProvidersOptions,
} = useFiltersOptions()

const shouldShowAllFilters = ref(false)

function toggleMoreFilters() {
  shouldShowAllFilters.value = !shouldShowAllFilters.value
}
</script>
